// extracted by mini-css-extract-plugin
export default {"metrics_pm":"MemorandumEnviValues_metrics_pm__PDlwP","column_metrics":"MemorandumEnviValues_column_metrics__Zx+2c"};